import { useState } from "react";
import Table from "../../ChildComponents/Table";
import { MdEditDocument } from "react-icons/md";
import Checkbox from "../../ChildComponents/Checkbox";
import { toast } from "react-toastify";
import { useGetUser } from "../../store/api/authApi";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useUpdateUser } from "../../store/api/authApi";

function RepotersList({ onEdit }) {
  const queryClient = useQueryClient();
  const [statusId, setStatusId] = useState(null);

  const updateUser = useUpdateUser(statusId);
  const getUser = useGetUser();
  const {
    data: repotersData,
    isLoading: isrepoterLoading,
    error: repoterError,
    refetch,
  } = useQuery({ queryKey: ["repoter"], queryFn: getUser });

  const mutation = useMutation({
    mutationFn: (data) => {
      return updateUser(data);
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries(["repoter"]);
      toast.success("Updated Successfuly");
      refetch();
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  const onToggleStatus = (user) => {
    setStatusId(user._id);
    const newStatus = user.userStatus ? false : true;
    try {
      mutation.mutate({
        userStatus: newStatus,
      });
    } catch (error) {
      console.error("Caught error in onToggleStatus:", error.message);
      toast.error(error.message || "Something went wrong");
    }
  };

  const data = repotersData?.user
    ?.map((e, i) => {
      return {
        index: i + 1,
        name: e?.fullName || e?.email || "Not set yet",
        role: e?.role?.name || "Not set yet",
        userStatus: (
          <Checkbox
            id={`user-status-${e._id}`}
            checked={e?.userStatus}
            onChange={() => onToggleStatus(e)}
            className="cursor"
          />
        ),
        actionButton: (
          <button onClick={() => onEdit(e)} className="btn text-success mx-2">
            <MdEditDocument />
          </button>
        ),
      };
    })
    .reverse();

  const columns = [
    {
      header: "SL#",
      accessor: "index",
    },
    {
      header: "Name or Email",
      accessor: "name",
    },
    {
      header: "Role",
      accessor: "role",
    },
    {
      header: "User Status",
      accessor: "userStatus",
    },
    {
      header: "Actions",
      accessor: "actionButton",
    },
  ];
  return (
    <div>
      <Table columns={columns} data={data} isLoading={isrepoterLoading} />
    </div>
  );
}

export default RepotersList;
